var _g, _g2, _g3, _g4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMagnifyingGlass(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    fill: "#ffffff",
    height: 451.7,
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "196.7 57.8 455.6 451.7",
    width: 455.6,
    zoomAndPan: "magnify",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "change1_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M348.72,361.78c-83.81,0-152-68.18-152-152s68.18-152,152-152,152,68.18,152,152S432.53,361.78,348.72,361.78Zm0-279a127,127,0,1,0,127,127A127.14,127.14,0,0,0,348.72,82.8Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "change1_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M458.48,378.21a14,14,0,0,1-9.94-23.86l38.71-39A14,14,0,1,1,507.13,335l-38.71,39A14,14,0,0,1,458.48,378.21Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "change1_3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M626.46,509.49a23.92,23.92,0,0,1-17.17-7.22l-103-105.48a24,24,0,0,1,34.34-33.55l103,105.48a24,24,0,0,1-17.17,40.77Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "change1_4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M348.47,316.84c-19.58,0-45.46-5.61-73.16-26.92-24.32-18.7-35.53-47.47-32.43-83.18A162.66,162.66,0,0,1,254.67,159a7.5,7.5,0,0,1,13.69,6.13h0a150,150,0,0,0-10.57,43.27c-2.56,30.6,6.41,54,26.66,69.6,50,38.48,92.75,18.6,93.18,18.39a7.5,7.5,0,1,1,6.51,13.51C383.07,310.45,369.36,316.84,348.47,316.84Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingGlass);
export default __webpack_public_path__ + "static/media/Magnifying Glass.dedc6abf031a26b2fd6724bd12a5c259.svg";
export { ForwardRef as ReactComponent };